import MetaFootballModel from "../../../../Football/Models/Pagination/MetaFootballModel";
import ClassicQuizUserRank from "./ClassicQuizUserRank";

export default class ClassicQuizUserRankModel {
  public meta: MetaFootballModel = new MetaFootballModel();
  public data: ClassicQuizUserRank[] = [];
}
